var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEthLogo = function SvgEthLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.96 4.375L13.831 4.81364V17.5419L13.96 17.6707L19.8684 14.1784L13.96 4.375Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9591 4.375L8.05072 14.1784L13.9591 17.6708V11.4929V4.375Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9589 18.7897L13.8862 18.8784V23.4125L13.9589 23.6249L19.8707 15.2991L13.9589 18.7897Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.959 23.6249V18.7897L8.05066 15.2991L13.959 23.6249Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9579 17.6708L19.8661 14.1784L13.9579 11.4929V17.6708Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05066 14.1784L13.9589 17.6708V11.4929L8.05066 14.1784Z",
    fill: "#393939"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEthLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eth_logo.a3718dab.svg";
export { ForwardRef as ReactComponent };